import { range } from "@suse-o11y/range";
import { round } from "@suse-o11y/round";
import { shuffle } from "@suse-o11y/shuffle";
import { useMemo } from "react";

const PERCENTAGES = range(0, 99);

export function usePseudoRandomIntGenerator({
	min,
	max,
	step,
}: {
	min: number;
	max: number;
	step: number;
}): (index: number) => number {
	return useMemo(() => {
		const sequence = shuffle(PERCENTAGES);

		return (index: number) => {
			const percent = sequence[index % sequence.length] / 100;

			const value = min + (max - min) * percent;

			return round(value / step, 0) * step;
		};
	}, [min, max, step]);
}
